__turbopack_context__.v({
  "content": "styles-module__E19D3W__content",
  "ctaRow": "styles-module__E19D3W__ctaRow",
  "headline": "styles-module__E19D3W__headline",
  "highlight": "styles-module__E19D3W__highlight",
  "primaryCta": "styles-module__E19D3W__primaryCta",
  "root": "styles-module__E19D3W__root",
  "secondaryCta": "styles-module__E19D3W__secondaryCta",
  "storeBadges": "styles-module__E19D3W__storeBadges",
  "sub": "styles-module__E19D3W__sub",
});
